<template>
  <div class="partner-area pb-75">
    <div class="container mw-1356">
      <div class="row justify-content-center">
        <div
          v-for="(partner, index) in partners"
          :key="index"
          class="col-xxl-2 col-sm-6 col-md-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="(index + 1) * 100"
        >
          <a href="https://wa.me/447429916178" target="_blank" class="partner-bg mb-4">
            <img :src="partner.image" :alt="partner.alt" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PartnerLogo",
  setup() {
    const partners = ref([
      {
        image: require("@/assets/images/partner-1.png"),
        link: "https://wa.me/447429916178",
        alt: "دعم الشاشات الذكية Smart TV",
      },
      {
        image: require("@/assets/images/partner-2.png"),
        link: "https://wa.me/447429916178",
        alt: "دعم أجهزة الأندرويد Android Box",
      },
      {
        image: require("@/assets/images/partner-3.png"),
        link: "https://wa.me/447429916178",
        alt: "دعم أجهزة شاومي وماج ميرور",
      },
      {
        image: require("@/assets/images/partner-4.png"),
        link: "https://wa.me/447429916178",
        alt: "دعم هواتف الأيفون والأيباد iOS",
      },
      {
        image: require("@/assets/images/partner-5.png"),
        link: "https://wa.me/447429916178",
        alt: "دعم هواتف وأجهزة الأندرويد Mobile",
      },
      {
        image: require("@/assets/images/partner-6.png"),
        link: "https://wa.me/447429916178",
        alt: "دعم الحواسيب والماك الكمبيوتر",
      },
    ]);

    return { partners };
  },
});
</script>